import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"
import { ChakraComponent, styled } from "@chakra-ui/react"
import styles from "./popover.module.css"

const Popover = styled(PopoverPrimitive.Root, {
  baseStyle(props) {
    return {}
  }
})

const PopoverTrigger = styled(PopoverPrimitive.Trigger, {
  baseStyle(props) {
    return {}
  }
})
const StyledPopoverContent: ChakraComponent<
  React.ForwardRefExoticComponent<
    PopoverPrimitive.PopoverContentProps & React.RefAttributes<HTMLDivElement>
  >,
  {}
> = styled(PopoverPrimitive.Content, {
  baseStyle(props) {
    if (!!props["data-transparant"]) {
        return { borderColor: `${props.color}40`, background: `${props.color}0D` }
    }
    return { borderColor: props.color, background: props.color }
  }
})

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = "center", sideOffset = 4, ...props }, ref) => (
  <>
    <PopoverPrimitive.Portal>
      <StyledPopoverContent
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={styles.popoverContent}
        {...props}
      />
    </PopoverPrimitive.Portal>
  </>
))

export { Popover, PopoverTrigger, PopoverContent }
